/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface CreditAnalyticsOverview {
  total_used: number;
  total_granted: number;
  net: number;
  entry_count: number;
  daily_average: number;
  top_category: string | null;
  top_category_label: string | null;
  top_category_credits: number;
  top_member_name: string | null;
  top_member_credits: number;
}
